<script setup lang="ts">
// console.debug(`${new Date().toISOString()} ${performance.now().toFixed(2)}ms [${import.meta.url}]`)
import UiToast from './ui/UiToast.vue'
import { useSessionUI } from './utils/composables/useSessionUI'
import { log } from './utils/logger'
import { useSysStore } from './valorador/stores/sysStore'

import MarketWarning from './valorador/widgets/MarketWarning.vue'

// Pinia
const sysStore = useSysStore()
sysStore.initSysStore()

const { isF1, isF2, isF3 } = useSessionUI()

function debounce<Args extends unknown[]>(
    fn: (...args: Args) => void,
    delay: number
): (...args: Args) => void {
    let timeoutId: ReturnType<typeof setTimeout> | undefined

    return (...args: Args) => {
        clearTimeout(timeoutId)
        timeoutId = setTimeout(() => fn(...args), delay)
    }
}

const debouncedSave = debounce(() => sysStore.saveState(), 300)

sysStore.$subscribe(() => {
    debouncedSave()
})

// e.ctrlKey && e.metaKey && e.altKey && e.key === 'F3'
window.addEventListener('keydown', (e: any) => {
    // log.info('handleKey:', e)
    if (e.altKey && e.key === 'F1') {
        isF1.value = !isF1.value
        e.preventDefault()
    } else if (e.altKey && e.key === 'F2') {
        isF2.value = !isF2.value
        e.preventDefault()
    } else if (e.altKey && e.key === 'F3') {
        isF3.value = !isF3.value
        e.preventDefault()
    }
})

const dismiss = () => {
    sysStore.accept()
}
</script>

<template>
    <div v-show="sysStore.isSysReady">
        <RouterView />
        <MarketWarning />
    </div>
    <div v-show="!sysStore.isSysReady" style="background: black; width: 100vw; height: 100vh"></div>

    <UiToast :open="!sysStore.accepted" severity="neutral" position="bottom-right" @close="dismiss">
        <span>Proyecto sin ánimo de lucro y sin trampa con tus datos.</span>
        <span>Consulta la guía para ver los detalles de fuentes de datos y el aviso legal.</span>
    </UiToast>
</template>

<style scoped></style>
